import {factoryItems} from '../Config/FactoryBoxContainer.constants';
import React from 'react';
import FactoryBox from '../../../Presentational Components/FactoryBox';
import AuthenticationWithClick from '../../../HOC/AuthenticationWithClick';
import {PATS_NAMES_ROUTES} from '../../../configuration/index.config';
import {IPropsView} from '../Config/FactoryBoxContainer.types';
const FactoryBoxWrapper = AuthenticationWithClick(FactoryBox);
const FactoryBoxContainer = (props:IPropsView) => (
    <>
        {factoryItems.map((factoryItem, index) => (
            <div key={index} className='ai-factory-item-container'>
                <p className='ai-factory-p'>{factoryItem.title}</p>
                <div className='ai-factory-items-top'>
                    {factoryItem.factoryBoxes.map((boxProps) =>
                        <FactoryBoxWrapper
                            key={boxProps.title}
                            {...props}
                            src={boxProps.src}
                            title={boxProps.title}
                            authenticationKey={boxProps.authenticationKey}
                            onClick={PATS_NAMES_ROUTES[boxProps.authenticationKey] && (() => props.history.push(`/${PATS_NAMES_ROUTES[boxProps.authenticationKey]}`))}
                            calssTYpe='disable'/>)}
                </div>
            </div>))}
    </>
);

export default FactoryBoxContainer;
